<script lang="ts">
	import decorationVertical from "@assets/images/deco/decoration - vertical-1.svg";
	import calendar from "@core/assets/icons/calendar.svg?raw";
	import { type FaqPage, homepageData } from "../../data/homepageData.js";
	import Link from "../common/Link.svelte";
	import { ButtonVariant } from "../common/getButtonClass.js";
	import FaqItem from "./FaqItem.svelte";

	const {
		h1 = false,
		page,
	}: {
		h1?: boolean;
		page?: FaqPage;
	} = $props();

	const displayedFaqs =
		page !== undefined ? homepageData.faqs.filter((faq) => faq.pages.includes(page)) : homepageData.faqs;
	const isCompact = page !== undefined && page !== "faq";
</script>

<section class="full-width relative overflow-hidden py-8 md:py-12">
	<div class="flex flex-col items-center gap-6 sm:gap-8 md:gap-12 xl:gap-16 relative px-4 md:px-0">
		<div
			class="absolute left-1/2 top-0 -translate-x-1/2 -z-10 pointer-events-none flex items-center justify-center {isCompact
				? 'h-[800px] sm:h-[1000px] md:h-[1200px] max-w-[2100px] w-full'
				: 'h-[1200px] w-[195vw] sm:w-[185vw] sm:h-[1950px]'}"
		>
			<img src={decorationVertical} alt="Dekorace" class="w-full h-full object-cover" />
		</div>

		{#if h1}
			<h1 class="text-center w-full max-w-[57.5rem] px-4">Často kladené otázky</h1>
		{:else}
			<h2 class="text-center w-full max-w-[57.5rem] px-4">Často kladené otázky</h2>
		{/if}

		<div class="flex flex-col gap-3 md:gap-4 w-full max-w-[20rem] md:max-w-[35rem] xl:max-w-[50.0625rem] px-4 md:px-0">
			{#each displayedFaqs as faq, index (index)}
				<FaqItem question={faq.question} answer={faq.answer} buttonText={faq.buttonText} buttonHref={faq.buttonHref} />
			{/each}
		</div>

		<Link variant={ButtonVariant.PrimaryMedium} href="/procedury" iconStart={calendar}>Chci si vybrat proceduru</Link>
	</div>
</section>
